import { v4 as uuidv4 } from 'uuid'

export const keyEEStaffRiskTestData = {
  title: 'Key EE / Staff Risk',
  item: '1 Partner Expresses desire to retire in >24 Months',
  key: uuidv4()
}
